import type React from 'react';
import { dayjs } from 'src/helper/date';
import { BRAND_NAME } from 'src/shared/constants/brand';

// Text only: the DS auth shell draws the footer line around it.
const AuthCopyright: React.FC = () => (
  <>
    Copyright © {dayjs().format('YYYY')} {BRAND_NAME}. All rights reserved.
  </>
);

export default AuthCopyright;
